function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Chevron from 'svg/chevron-right.svg';
import Select from 'components/Form/Select';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import { DAYS_SELECTOR_ZOOM } from '../../constants';
import styles from './DaysSelectorControlBtn.pcss';
var _React_PureComponent;
class DaysSelectorControlBtn extends (_React_PureComponent = React.PureComponent) {
    get signProps() {
        const { daysSelectorPage, setDaysSelectorPage, daysSelectorTotalPages } = this.props;
        if (daysSelectorTotalPages === 1 || daysSelectorTotalPages === 0) {
            return {
                plusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                },
                minusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                }
            };
        }
        if (daysSelectorPage <= 0) {
            return {
                plusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign),
                    onClick: ()=>setDaysSelectorPage(daysSelectorPage + 1)
                },
                minusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                }
            };
        }
        if (daysSelectorPage >= daysSelectorTotalPages - 1) {
            return {
                plusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign, styles['daysSelectorScrollBtn__sign--disabled']),
                    disabled: true
                },
                minusSignProps: {
                    className: cn(styles.daysSelectorScrollBtn__sign),
                    onClick: ()=>setDaysSelectorPage(daysSelectorPage - 1)
                }
            };
        }
        return {
            plusSignProps: {
                className: cn(styles.daysSelectorScrollBtn__sign),
                onClick: ()=>setDaysSelectorPage(daysSelectorPage + 1)
            },
            minusSignProps: {
                className: cn(styles.daysSelectorScrollBtn__sign),
                onClick: ()=>setDaysSelectorPage(daysSelectorPage - 1)
            }
        };
    }
    get options() {
        return [
            {
                label: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[`zoom${DAYS_SELECTOR_ZOOM.day}`])),
                value: DAYS_SELECTOR_ZOOM.day
            },
            {
                label: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[`zoom${DAYS_SELECTOR_ZOOM.week}`])),
                value: DAYS_SELECTOR_ZOOM.week
            },
            {
                label: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[`zoom${DAYS_SELECTOR_ZOOM.month}`])),
                value: DAYS_SELECTOR_ZOOM.month
            }
        ];
    }
    render() {
        const { daysSelectorZoom, setDaysSelectorZoom } = this.props;
        const { plusSignProps, minusSignProps } = this.signProps;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.root,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.daysSelectorScrollBtn,
                children: [
                    /*#__PURE__*/ _jsx(Select, {
                        className: "controlSelect",
                        optionsFrom: this.options,
                        valueKey: "value",
                        labelKey: "label",
                        onChange: ({ value })=>setDaysSelectorZoom(value),
                        value: daysSelectorZoom
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.daysSelectorScrollBtn__signs,
                        children: [
                            /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
                                type: "button"
                            }, minusSignProps), {
                                children: /*#__PURE__*/ _jsx(Chevron, {
                                    className: cn(styles['daysSelectorScrollBtn__signIcon--backwards'])
                                })
                            })),
                            /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
                                type: "button"
                            }, plusSignProps), {
                                children: /*#__PURE__*/ _jsx(Chevron, {})
                            }))
                        ]
                    })
                ]
            })
        });
    }
}
_define_property(DaysSelectorControlBtn, "propTypes", {
    // Implicit props
    daysSelectorZoom: PropTypes.string,
    daysSelectorPage: PropTypes.number,
    daysSelectorTotalPages: PropTypes.number,
    // Implicit actions
    setDaysSelectorZoom: PropTypes.func,
    setDaysSelectorPage: PropTypes.func
});
const mapStateToProps = (state)=>({
        daysSelectorZoom: selectors.daysSelectorZoom(state),
        daysSelectorPage: selectors.daysSelectorPage(state),
        daysSelectorTotalPages: selectors.daysSelectorTotalPages(state)
    });
const mapDispatchToProps = (dispatch)=>({
        setDaysSelectorZoom: (zoom)=>dispatch(actions.setDaysSelectorZoomSmartPage(zoom)),
        setDaysSelectorPage: (zoom)=>dispatch(actions.setDaysSelectorPage(zoom))
    });
const ConnectedDaysSelectorControlBtn = connect(mapStateToProps, mapDispatchToProps)(DaysSelectorControlBtn);
export default withStyles(styles)(ConnectedDaysSelectorControlBtn);
